import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CatalogService } from "../../services/catalog.service";
import { findAreasCatalogAct, findBenefitGroupsCatalogAct, findBenefitsCatalogAct, findBenefitTypeCatalogAct, findCostsPerEmployeeGroupsCatalogAct, findCostsPerEmployeesCatalogAct, findCostsPerEmployeeTypeCatalogAct, findDivisionsCatalogAct, 
    findFormulaGroupsCatalogAct, 
    findHolidayGroupsCatalogAct, 
    findObjectsCatalogAct, 
    findSignatureGroupsCatalogAct, 
    findSignatureTypeCatalogAct, findUsersWithRolAutCatalogAct, findVariablesCatalogAct, findWithholdingGroupsCatalogAct, findWithholdingsCatalogAct, findWithholdingTypeCatalogAct, loadAreasCatalogAct, loadBenefitGroupsCatalogAct, loadBenefitsCatalogAct,
    loadBenefitTypeCatalogAct, loadCostsPerEmployeeGroupsCatalogAct, loadCostsPerEmployeesCatalogAct, loadCostsPerEmployeeTypeCatalogAct, loadDivisionsCatalogAct, loadFormulaGroupsCatalogAct, loadHolidayGroupsCatalogAct, loadObjectsCatalogAct, loadSignatureGroupsCatalogAct, loadSignatureTypeCatalogAct, loadUsersWithRolAutCatalogAct,
    loadVariablesCatalogAct,
    loadWithholdingGroupsCatalogAct,
    loadWithholdingsCatalogAct,
    loadWithholdingTypeCatalogAct, 
    } from "./catalog-offer.actions";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs/internal/observable/of";

@Injectable()
export class CatalogOfferEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private catalogService = inject(CatalogService);

    findDivisionsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findDivisionsCatalogAct),
            exhaustMap(() => this.catalogService.findDivisionsCatalog()
        .pipe(
            map(divisions => loadDivisionsCatalogAct({ divisions })),
            catchError(error => of(error))
        ))
        )
    );

    findAreasCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findAreasCatalogAct),
            exhaustMap(() => this.catalogService.findAreasCatalog()
        .pipe(
            map(areas => loadAreasCatalogAct({ areas })),
            catchError(error => of(error))
        ))
        )
    );

    findBenefitTypeCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findBenefitTypeCatalogAct),
            exhaustMap(() => this.catalogService.findBenefitTypeCatalog()
        .pipe(
            map(benefitTypes => loadBenefitTypeCatalogAct({ benefitTypes })),
            catchError(error => of(error))
        ))
        )
    );

    findBenefitsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findBenefitsCatalogAct),
            exhaustMap(() => this.catalogService.findBenefitsCatalog()
        .pipe(
            map(benefits => loadBenefitsCatalogAct({ benefits })),
            catchError(error => of(error))
        ))
        )
    );

    findSignatureTypeCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findSignatureTypeCatalogAct),
            exhaustMap(() => this.catalogService.findSignatureTypeCatalog()
        .pipe(
            map(signatureTypes => loadSignatureTypeCatalogAct({ signatureTypes })),
            catchError(error => of(error))
        ))
        )
    );

    findUsersWithRolAutCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findUsersWithRolAutCatalogAct),
            exhaustMap(() => this.catalogService.findUsersWithRolAutCatalog()
        .pipe(
            map(usersWithRolAut => loadUsersWithRolAutCatalogAct({ usersWithRolAut })),
            catchError(error => of(error))
        ))
        )
    );

    findSignatureGroupsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findSignatureGroupsCatalogAct),
            exhaustMap(() => this.catalogService.findSignatureGroupsCatalog()
        .pipe(
            map(signatureGroups => loadSignatureGroupsCatalogAct({ signatureGroups })),
            catchError(error => of(error))
        ))
        )
    );

    findBenefitGroupsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findBenefitGroupsCatalogAct),
            exhaustMap(() => this.catalogService.findBenefitGroupsCatalogAct()
        .pipe(
            map(benefitGroups => loadBenefitGroupsCatalogAct({ benefitGroups })),
            catchError(error => of(error))
        ))
        )
    );

    findHolidayGroupsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findHolidayGroupsCatalogAct),
            exhaustMap(() => this.catalogService.findHolidayGroupsCatalogAct()
        .pipe(
            map(holidayGroups => loadHolidayGroupsCatalogAct({ holidayGroups })),
            catchError(error => of(error))
        ))
        )
    );

    findWithholdingsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findWithholdingsCatalogAct),
            exhaustMap(() => this.catalogService.findWithholdingsCatalog()
        .pipe(
            map(withholdings => loadWithholdingsCatalogAct({ withholdings })),
            catchError(error => of(error))
        ))
        )
    );

    findWithholdingTypeCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findWithholdingTypeCatalogAct),
            exhaustMap(() => this.catalogService.findWithholdingTypeCatalog()
        .pipe(
            map(withholdingTypes => loadWithholdingTypeCatalogAct({ withholdingTypes })),
            catchError(error => of(error))
        ))
        )
    );

    findCostsPerEmployeesCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findCostsPerEmployeesCatalogAct),
            exhaustMap(() => this.catalogService.findCostsPerEmployeesCatalog()
        .pipe(
            map(costsPerEmployees => loadCostsPerEmployeesCatalogAct({ costsPerEmployees })),
            catchError(error => of(error))
        ))
        )
    );

    findCostsPerEmployeeTypeCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findCostsPerEmployeeTypeCatalogAct),
            exhaustMap(() => this.catalogService.findCostsPerEmployeeTypeCatalog()
        .pipe(
            map(costsPerEmployeeTypes => loadCostsPerEmployeeTypeCatalogAct({ costsPerEmployeeTypes })),
            catchError(error => of(error))
        ))
        )
    );

    findVariablesCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findVariablesCatalogAct),
            exhaustMap(() => this.catalogService.findVariablesCatalog()
        .pipe(
            map(variables => loadVariablesCatalogAct({ variables })),
            catchError(error => of(error))
        ))
        )
    );

    findObjectsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findObjectsCatalogAct),
            exhaustMap(() => this.catalogService.findObjectsCatalog()
        .pipe(
            map(objects => loadObjectsCatalogAct({ objects })),
            catchError(error => of(error))
        ))
        )
    );

    findWithholdingGroupsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findWithholdingGroupsCatalogAct),
            exhaustMap(() => this.catalogService.findWithholdingGroupsCatalog()
        .pipe(
            map(withholdingGroups => loadWithholdingGroupsCatalogAct({ withholdingGroups })),
            catchError(error => of(error))
        ))
        )
    );

    findFormulaGroupsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findFormulaGroupsCatalogAct),
            exhaustMap(() => this.catalogService.findFormulaGroupsCatalog()
        .pipe(
            map(formulaGroups => loadFormulaGroupsCatalogAct({ formulaGroups })),
            catchError(error => of(error))
        ))
        )
    );

    findCostsPerEmployeeGroupsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findCostsPerEmployeeGroupsCatalogAct),
            exhaustMap(() => this.catalogService.findHCostsPerEmployeeGroupsCatalog()
        .pipe(
            map(costsPerEmployeeGroups => loadCostsPerEmployeeGroupsCatalogAct({ costsPerEmployeeGroups })),
            catchError(error => of(error))
        ))
        )
    );

}